import { encoding_for_model } from '@dqbd/tiktoken'
import { get } from 'svelte/store'

import { browser } from '$app/environment'
import { messages } from '$lib/messages'
import { apiPostJson } from '$lib/proxy/apiProxy'

import { account } from '../account/account'
import { setAccount } from '../account/manager'
import { OpenaiThreadItemAppendTokensToLastMessage } from '../openai_thread_items/manager'
import { Features_Name, getAccPlanFeatures } from '../subscription_acc_plan_features/subscription_acc_plan_features'
import { openai_tokens_store } from './openai'


export function getOpenaiTokensLimit(): number {
	const feature = getAccPlanFeatures(Features_Name.AI_Assistant)
	if (!feature) return 0
	const feature_params = JSON.parse(feature.params)
	const tokens_limit =  feature_params.per_1_month
	return tokens_limit
}

export async function checkLimitReached() {
	if (!browser) return false

	const tokens_used = get(account).openai_tokens

	const feature = getAccPlanFeatures(Features_Name.AI_Assistant)
	if (!feature) return false
	const feature_params = JSON.parse(feature.params)
	const tokens_limit =  feature_params.per_1_month

	if (tokens_used >= tokens_limit) {
		return true
	}

	return false
}


export function openaiTokensAdd(text: string) {
	const tokens = getTokens(text)
	
	upsertOpenaiTokens(tokens)
	OpenaiThreadItemAppendTokensToLastMessage(tokens)
	
	// update account.openai_tokens // skip save the value is recived from the backend
	// calculated as sum(tokens) from all openai_tokens of this month
	const currentTokens = get(account).openai_tokens
	setAccount({ openai_tokens: currentTokens + tokens }, true)

}

export function openaiTokensAddDiff(originalText: string, updatedText: string) {
	const originalTokens = getTokens(originalText)
	const updatedTokens = getTokens(updatedText)
	const tokens = (updatedTokens - originalTokens)
	
	upsertOpenaiTokens(tokens)
	OpenaiThreadItemAppendTokensToLastMessage(tokens)

	// update account.openai_tokens // skip save the value is recived from the backend 
	// calculated as sum(tokens) from all openai_tokens of this month
	const currentTokens = get(account).openai_tokens
	setAccount({ openai_tokens: currentTokens +  tokens }, true)
}

function getTokens(text: string) {
	return encoding_for_model('gpt-4o').encode(text).length
}


function upsertOpenaiTokens(tokens: number) {

	openai_tokens_store.update(val => val + tokens)

}

export async function saveOpenaiTokens() {

	const tokens = get(openai_tokens_store)
	openai_tokens_store.set(0)

	const jsonData = await apiPostJson('/openai_tokens/upsert', { tokens })
	if (jsonData?.error) {
		messages.error('Internal error - please contact the administrator.')
	}

}
